import React, { useMemo } from "react";
import { ChevronDownIcon } from "../../icons";
import BeneficiaryAvatar from "./BeneficiaryAvatar";

const BeneficiaryListItem = ({ beneficiary, isSelected, onSelect }) => {
  // Determine best display name
  const displayName = useMemo(() => {
    if (!beneficiary) return "Unknown Beneficiary";
    
    if (beneficiary.beneficiary_type === "INDIVIDUAL") {
      return `${beneficiary?.beneficiary_first_name ?? ""} ${beneficiary?.beneficiary_last_name ?? ""}`;
    } 
    if (beneficiary?.beneficiary_legal_name) {
      return beneficiary?.beneficiary_legal_name;
    }

    return beneficiary.label || "Beneficiary";
  }, [beneficiary]);

  // Optional: Clean wallet address shortening helper
  const walletAddress = beneficiary?.wallet_address || "N/A";

  return (
    <button
      type="button"
      onClick={() => onSelect?.(beneficiary)}
      className={`relative flex h-[82px] w-full shrink-0 items-center gap-[10px] rounded-[8px] px-[14px] py-[15px] text-left custom-transition ${
        isSelected
          ? "bg-[rgba(74,185,50,0.08)]"
          : "bg-background-alt hover:bg-option-hover"
      }`}
    >
      {/* Left Details Group */}
      <div className="flex items-center gap-3 min-w-0 flex-1">
        {/* Avatar */}
        <BeneficiaryAvatar
          name={displayName}
          className="shrink-0"
        />

        {/* Info Column */}
        <div className="flex flex-col min-w-0 flex-1 justify-center gap-0.5">
          {/* Main Title */}
          <div className="flex items-center space-x-2">
            <p className="text-sm font-semibold leading-normal text-text-primary truncate">
              {displayName} 

            </p>
            {/* {beneficiary?.asset_id && (
              <p className="text-sm font-semibold leading-normal text-text-primary truncate">
                ({beneficiary.asset_id})
              </p>
            )} */}
            {beneficiary?.currency_short && (
              <p className="text-sm font-semibold leading-normal text-text-primary truncate">
                ({beneficiary.currency_short} : {beneficiary.network_name})
              </p>
            )}

          </div>

          {/* Subtitle Rows */}
          <div className="flex flex-col text-[11px] font-medium text-text-secondary leading-tight">
            <span className="truncate">
              <span className="font-semibold text-text-secondary">Wallet Address:</span>{" "}
              {walletAddress}
            </span>
          </div>
        </div>
      </div>

      <div className="flex size-[20px] shrink-0 items-center justify-center">
        <ChevronDownIcon size={20} className="-rotate-90 text-text-secondary" />
      </div>
    </button>
  );
};

export default React.memo(BeneficiaryListItem);